module.exports = __webpack_public_path__ + "img/lkz_ico_12.3bd8de6e.svg";